import React, { useState } from "react";
import {
  ClipboardDocumentCheckIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import Card from "../../../componentLibrary/Card";
import SlidingContainer from "../../../componentLibrary/SlidingContainer";
import Accordion from "../../../componentLibrary/Accordion";
import Tooltip from "../../../componentLibrary/Tooltip";
import {
  SectionEmptyState,
  SectionHeader,
  SectionPanel,
} from "../../../componentLibrary/SectionPanel";

export default function ContainerComponents() {
  const [isShowingCard, setIsShowingCard] = useState(true);

  const [accordianItem] = useState(["Item 1", "Item 2", "Item 3"]);

  return (
    <>
      <h2 className="underline mb-2">Container Components</h2>

      <div className="mb-4">
        <h3>Card Components</h3>
        <div className="mb-4 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
          <p className="text-sm text-gray-700">
            Content containers used throughout the application for displaying
            structured information. Used in dashboard layouts, data displays,
            and content organization. Features optional headers, footers, and
            close functionality for dynamic content management.
          </p>
        </div>
        <div className="space-y-2">
          <Card title="Card title" footer="Card footer">
            Card body
          </Card>
          {isShowingCard && (
            <Card
              title="Closable Card"
              footer="Card footer"
              onClose={() => setIsShowingCard(false)}
            >
              Add onClose to trigger an onClose function
            </Card>
          )}
        </div>
      </div>
      <div className="mb-4">
        <h3>Section panel</h3>
        <div className="mb-4 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
          <p className="text-sm text-gray-700">
            Outlined cards for toolbox-style sections: optional icon + title
            header, optional header action link, and a centered empty state for
            placeholder copy.
          </p>
        </div>
        <div className="space-y-4 max-w-md">
          <SectionPanel>
            <SectionHeader
              icon={
                <ClipboardDocumentCheckIcon className="w-5 h-5 text-electrum-300 shrink-0" />
              }
              title="Check-ins"
            />
            <SectionEmptyState>
              <p className="text-sm text-gray-400 py-2">
                No check-ins yet. Add one to see them listed here.
              </p>
            </SectionEmptyState>
          </SectionPanel>
          <SectionPanel>
            <SectionHeader
              icon={
                <InformationCircleIcon className="w-5 h-5 text-electrum-300 shrink-0" />
              }
              title="With header action"
              action="View details"
              actionTo="/"
            />
            <SectionEmptyState>
              <p className="text-sm text-gray-400 py-2">
                Optional header link uses React Router.
              </p>
            </SectionEmptyState>
          </SectionPanel>
        </div>
      </div>
      <div className="mb-4">
        <h3>Sliding Container</h3>
        <div className="mb-4 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
          <p className="text-sm text-gray-700">
            Expandable content containers with smooth animations. Used for
            progressive disclosure of information and content organization.
            Features customizable action buttons and indicators for enhanced
            user interaction.
          </p>
        </div>
        <div className="space-y-2">
          <SlidingContainer
            title="Sliding Container"
            hasAction={true}
            actionLabel="View All"
            onActionClick={() => {}}
            indicatorClassName=""
            actionButtonClassName="max-w-24 px-2"
          />
        </div>
      </div>
      <div className="mb-4">
        <h3>Accordion</h3>
        <div className="mb-4 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
          <p className="text-sm text-gray-700">
            Collapsible content sections for organizing related information.
            Used in lesson content, help sections, and data organization.
            Supports custom headers, default open states, and flexible content
            layouts for various use cases.
          </p>
        </div>
        <div className="space-y-2">
          <Accordion
            title={
              <div className="flex items-center gap-2">
                <div className="text-md font-bold">Title Component</div>
                <Tooltip
                  icon={<InformationCircleIcon className="w-4 h-4" />}
                  text="Title can be a HTML element or a string."
                  position="right"
                  maxWidth={175}
                />
              </div>
            }
            defaultOpen={true}
            headerClassName="p-2 w-full"
          >
            {accordianItem.map((item, index) => (
              <div key={index} className="p-2 bg-gray-100 hover:bg-gray-200">
                {item}
              </div>
            ))}
          </Accordion>
        </div>
      </div>
    </>
  );
}
